export const errorTypes = {
  GENERIC: 'generic',
  EMAIL_UNAVAILABLE: 'emailUnavailable',
  POST_ERROR: 'postError',
  GET_ERROR: 'getError',
};

export const SET_ERROR = 'error/setError';
export const CLEAR_ERRORS = 'error/clearErrors';

const initialState = { errors: [] };

export const setError = ({ type = errorTypes.GENERIC, message }) => ({
  type: SET_ERROR,
  payload: { type, message },
});

export const clearErrors = types => ({ type: CLEAR_ERRORS, payload: { types } });

export const errorReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_ERROR:
      const { type, message } = action.payload;
      return { ...state, errors: [...state.errors, { type, message }] };
    case CLEAR_ERRORS:
      const errors = state.errors.filter(e => !action.payload.types.includes(e.type));
      return { ...state, errors };
    default:
      return state;
  }
};
